import Vue from 'vue'
import Vuex from 'vuex'

import * as shared from './shared'
import * as auth from './auth'
import * as rede from './rede'
import * as uf from './uf'
import * as tipoRede from './tipoRede'
import * as especialidade from './especialidadeRede'
import * as corpoClinico from './corpoClinico'
import * as redeUnidade from './redeUnidade'
import * as formBusca from './formBusca'
import * as exameRede from './exameRede'
import * as tipoRegistro from './tipoRegistro'
import * as sinSaude from './sinsaude'
import * as usuario from './user'
import * as singleRede from './singleRede'
import * as pedido from './pedido'
import * as orcamento from './orcamento'
import * as GerenciarAgendamento from './gerenciarAgendamento'
import * as Agendamento from './agendamento'
import * as payment from './payment'
import * as Local from './local'
import * as CartaoSin from './cartaoSin'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    shared,
    auth,
    rede,
    uf,
    tipoRede,
    especialidade,
    corpoClinico,
    redeUnidade,
    formBusca,
    exameRede,
    tipoRegistro,
    sinSaude,
    usuario,
    singleRede,
    pedido,
    orcamento,
    GerenciarAgendamento,
    Agendamento,
    payment,
    Local,
    CartaoSin
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js